<div class="widget-top-container d-flex justify-content-space-between">
  <h1>{{widgetData.title}}</h1>
  <a *ngIf="widgetData.fullCalendarLink" [href]="widgetData.fullCalendarLink.url" [target]="widgetData.fullCalendarLink.target" class="link">
    <span>{{widgetData.fullCalendarLink.title}}</span>
  </a>

 
</div>

<div class="filters">
  <mat-checkbox
      *ngFor="let item of widgetData.filters"
      class="radio-view"
      [ngStyle]="{'--control-color': FiltersColorHelper.getStyleColor(item.color)}"
      [checked]="item.checked"
      (change)="filterChange($event, item)"
      [disabled]="isLoading"
      >
      {{ item.label }}
    </mat-checkbox>
</div>

<div class="items-container" *ngIf="!isLoading">
  <ng-container *ngIf="eventsList?.length; else noItemsTemplate">
    <ng-template ngFor let-event [ngForOf]="eventsList">
        <div class="calendar-event-item d-flex">
          <div>
            <div class="date-container d-flex justify-content-center align-items-center" [ngStyle]="{'--color': event.color}">
                <ng-container *ngTemplateOutlet="event.isSameDay ? sameDateTemplate : twoDatesTemplate; context: { $implicit: event }"></ng-container>
            </div>
          </div>
          
          <div class="d-flex justify-content-space-between align-items-center calendar-event-item__content-container">
            <span class="calendar-event-item__title">{{event.title}}</span>
            <div *ngIf="event.toolTipContent && event.toolTipLabel; else noTooltip" 
                class="d-flex align-items-center calendar-event-item__tooltip" 
                [matTooltip]="event.toolTipContent"
                #tooltip="matTooltip" (click)="tooltip.toggle()">
              {{event.toolTipLabel}}
              <span class="question-icon">?</span>
            </div>
            <ng-template #noTooltip>
              <div *ngIf="event.toolTipLabel" class="d-flex align-items-center calendar-event-item__tooltip">
                {{event.toolTipLabel}}
              </div>
            </ng-template>
          </div>
        </div>
    </ng-template>
  </ng-container>
  
  <ng-template #noItemsTemplate>
    <p>{{widgetData.noResultsText}}</p>
  </ng-template>
</div>


<div class="items-container skeleton" *ngIf="isLoading">
    <app-skeleton *ngFor="let _ of [].constructor(5)"  [height]="82" class="calendar-event-item d-flex"/>
</div>


<!-- Template for the same day -->
<ng-template #sameDateTemplate let-event>
  <span class="date-container__day">{{ event.startDate | date: 'EEEE' : 'UTC' : utcCultureCode }}</span>
  <span class="date-container__day-number">{{ event.startDate.getDate() }}</span>
  <span class="date-container__month">{{ event.startDate | date: 'MMMM' : 'UTC' : utcCultureCode }}</span>
</ng-template>

<!-- Template for two dates -->
<ng-template #twoDatesTemplate let-event>
  <span class="date-container__day">
    {{ event.startDate | date: 'EEE' : 'UTC' : utcCultureCode }} - {{ event.endDate | date: 'EEE' : 'UTC' : utcCultureCode }}
  </span>
  <span class="date-container__day-number">
    {{ event.startDate.getDate() }} - {{ event.endDate.getDate() }}
  </span>
  <span *ngIf="event.startDate.getMonth() != event.endDate.getMonth()" class="date-container__month">
    {{ event.startDate | date: 'MMM' : 'UTC' : utcCultureCode }} - {{ event.endDate | date: 'MMM' : 'UTC' : utcCultureCode }}
  </span>
  <span *ngIf="event.startDate.getMonth() == event.endDate.getMonth()" class="date-container__month">
    {{ event.startDate | date: 'MMMM' : 'UTC' : utcCultureCode }}
  </span>
</ng-template>